export default "__VITE_ASSET__DNu_aShe__"